/* global axios */
import ApiClient from '../ApiClient';

class CaptainActionApprovals extends ApiClient {
  constructor() {
    super('captain/action_approvals', { accountScoped: true });
  }

  get({ page = 1, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        status,
      },
    });
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  reject(id) {
    return axios.post(`${this.url}/${id}/reject`);
  }
}

export default new CaptainActionApprovals();
